import { useSessionContext } from '@contexts/session'

const useIsModLogin = () => {
  const { id, modLoginUserId } = useSessionContext()

  return { isModLogin: !!modLoginUserId && modLoginUserId !== id?.toString() }
}

export default useIsModLogin
